import { IAppState } from '../../../AppModulesWrapper';

export const selectIsByHomeowner = (state: IAppState): boolean => {
  return state.servicePickerWidget.offer.isByHomeowner;
};
